function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4657 6.69375L13.322 4.8375C14.1079 4.12118 15.1396 3.73522 16.2027 3.75984C17.2658 3.78445 18.2785 4.21774 19.0304 4.96966C19.7824 5.72158 20.2157 6.73432 20.2403 7.79741C20.2649 8.86051 19.8789 9.89221 19.1626 10.6781L16.5095 13.3219C16.1271 13.7057 15.6727 14.0102 15.1724 14.218C14.6721 14.4258 14.1356 14.5328 13.5938 14.5328C13.0521 14.5328 12.5156 14.4258 12.0153 14.218C11.515 14.0102 11.0606 13.7057 10.6782 13.3219",
  stroke: "#3D2DAA",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5344 17.3062L10.6782 19.1625C9.89228 19.8788 8.86057 20.2648 7.79748 20.2402C6.73438 20.2155 5.72164 19.7823 4.96972 19.0303C4.2178 18.2784 3.78451 17.2657 3.7599 16.2026C3.73529 15.1395 4.12124 14.1078 4.83756 13.3219L7.49069 10.6781C7.87306 10.2943 8.32744 9.98978 8.82778 9.78198C9.32811 9.57419 9.86455 9.46722 10.4063 9.46722C10.9481 9.46722 11.4845 9.57419 11.9849 9.78198C12.4852 9.98978 12.9396 10.2943 13.3219 10.6781",
  stroke: "#3D2DAA",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Link.4f9ae155.svg";
export { ForwardRef as ReactComponent };